import React, { useEffect }  from 'react';
import '../../styles/App.scss';
import { useGlobalStore } from '../../utils/global-store/vo/Vo-globalStore';
import * as Sentry from "@sentry/react";

//local 
import ProductPage from '../../components/vo/product-page/ProductPage';

const VoProductApp = ({ moduleData,moduleName }) => {
  const [globalVariable, globalVariabledispatch] = useGlobalStore(false);
  globalVariabledispatch('SET_MODULE_DATA', { moduleData: moduleData });

  return (
    <div>
         <ProductPage></ProductPage>
    </div>
  );
}

//export default VoProductApp;
export default Sentry.withProfiler(VoProductApp);

